import Vue from 'vue'

// Layouts
Vue.component('dashboard', require('./../views/Layouts/Dashboard.vue').default);
Vue.component('customerDashboard', require('./../views/Layouts/CustomerDashboard.vue').default);
Vue.component('login', require('./../views/Layouts/Login.vue').default);
Vue.component('loading', require('./../views/Layouts/Loading.vue').default);

// Components
Vue.component('sidebar-menu', require('./SidebarMenu.vue').default);
Vue.component('bottom-bar', require('./Bottombar.vue').default);
Vue.component('nav-bar', require('./Navbar.vue').default);
Vue.component('loader', require('./Loader.vue').default);
Vue.component('datatable', require('./Datatable.vue').default);
Vue.component('table-checkbox', require('./TableOfCheckbox.vue').default);
Vue.component('client-selector', require('./ClientSelector.vue').default);
Vue.component('alternativeDateRangePicker', require("./AlternativeDateRangePicker.vue").default);
Vue.component('datatable-action', require("./DataTableAction.vue").default);
Vue.component('rfid-settings', require('./RFIDSettings.vue').default);
Vue.component('search-dialog', require('./SearchDialog.vue').default);
Vue.component('upload-files-international', require('./UploadFilesInternational.vue').default);
Vue.component('upload-files-national', require('./UploadFilesNational.vue').default);
Vue.component('datepicker', require('./DatePicker.vue').default);
Vue.component('create-fulfillment', require('./CreateFulfillment.vue').default);

// Dashboard Components
Vue.component('d-operations', require('./dashboard//Operations.vue').default);
Vue.component('d-audits', require('./dashboard//Audits.vue').default);
Vue.component('d-sales', require('./dashboard//Sales.vue').default);
Vue.component('d-fulfillment', require('./dashboard//Fulfillment.vue').default);
Vue.component('d-supervision', require('./dashboard//Supervision.vue').default);

// Yego Dashboard Components
Vue.component('efficiency', require('./yego_dashboard/efficiency.vue').default);
Vue.component('efficiency_options', require('./yego_dashboard/efficiency_options.vue').default);
Vue.component('buyout', require('./yego_dashboard/buyout.vue').default);
Vue.component('buyout_options', require('./yego_dashboard/buyout_options.vue').default);
Vue.component('days_in_transit', require('./yego_dashboard/days_in_transit.vue').default);
Vue.component('days_in_transit_options', require('./yego_dashboard/days_in_transit_options.vue').default);

// Customers
Vue.component('create-customer-form', require('./CreateCustomerForm.vue').default);

// Buttons
Vue.component('btn-primary', require('./buttons/primary.vue').default);
Vue.component('btn-secondary', require('./buttons/secondary.vue').default);
Vue.component('btn-pf', require('./buttons/primary_form.vue').default);
Vue.component('btn-sf', require('./buttons/secondary_form.vue').default);
Vue.component('btn-cancel', require('./buttons/cancel.vue').default);
Vue.component('btn-delete', require('./buttons/delete.vue').default);
Vue.component('btn-help', require('./buttons/help.vue').default);